import React, { useContext, useState } from "react";
import { createContext } from "react";

const TrackContext = createContext({
    typeModalTrack: "",
    setTypeModalTrack: () => { },
});

export default TrackContext;

export function TrackContextProvider({ children }) {
    const [typeModalTrack, setTypeModalTrack] = useState("");
    const [valueEditModal, setvalueEditModal] = useState("");
    const [updateList, setUpdateList] = useState(false);
    const [showAudioPlayer, setShowAudioPlayer] = useState(false);
    const [selectedTrackSearch, setSelectedTrackSearch] = useState("");
    const [changePlayList, setChangePlayList] = useState(false);
    return (
        <TrackContext.Provider
            value={{
                typeModalTrack,
                setTypeModalTrack,
                valueEditModal,
                setvalueEditModal,
                updateList,
                setUpdateList,
                showAudioPlayer,
                setShowAudioPlayer,
                selectedTrackSearch,
                setSelectedTrackSearch,
                changePlayList,
                setChangePlayList,
            }}
        >
            {children}
        </TrackContext.Provider>
    );
}
